<template>
    <v-autocomplete
            v-show="!(items.length === 1 && hideOnOne)"
            hide-details
            v-model="model"
            :items="items"
            item-text="name"
            item-value="id"
            :filled="filled"
            :label="label || 'Sucursal' + (isMultiple ? 'es' : '')"
            prepend-inner-icon="fa-building"
            @click:clear="clear"
            return-object
            :filter="filter"
            :multiple="isMultiple"
            :disabled="loading || disabled || items.length === 0"
            :required="isRequired"
    >
        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>

    </v-autocomplete>
</template>

<script>

    import {hasAccessToOffice} from '@/utils/Auth'
    import {filterSelectorWithHeaders} from '@/utils/Common'
    import {mapMutations, mapState, mapActions} from 'vuex'

    export default{
        props: [
            'default',
            'multiple',
            'required' ,
            'offices',
            'label',
            'disabled',
            'value',
            'onlyScoped',
            'hideOnOneItem',
            'filled'
        ],
        data(){
            return {
                model: this.multiple !== undefined && this.multiple !== false ? [] : null,
                loading: false
            }
        },
        watch: {
            model(val){
                this.$emit('change', val)
            },
            branchOffices(offices){
                this.syncModelFromValue()
                this.$emit('loaded')
            },
            currentProvider(val){},
            value(val){
                this.syncModelFromValue()
            }
        },
        mounted(){
            if (this.branchOffices.length === 0) {
                this.fetchBranchOffices()
            }else{
              this.syncModelFromValue()
              this.$emit('loaded')
            }
        },
        methods: {
            ...mapActions(['fetchBranchOffices']),
            ...mapMutations(['showSnackBar']),
            filter: filterSelectorWithHeaders,
            clear(){
                this.model = this.isMultiple ? [] : null
            },
            selectedIds(selection){
                if(!selection) return []
                const items = Array.isArray(selection) ? selection : [selection]
                return items.map(item => {
                    return item && item.id !== undefined ? item.id.toString() : item.toString()
                }).sort()
            },
            sameSelection(nextModel){
                const vm = this
                const currentIds = vm.selectedIds(vm.model)
                const nextIds = vm.selectedIds(nextModel)

                return currentIds.length === nextIds.length &&
                    currentIds.every((id, index) => id === nextIds[index])
            },
            setModelIfChanged(nextModel){
                if(this.sameSelection(nextModel)) return
                this.model = nextModel
            },
            syncModelFromValue(){
                const vm = this
                const value = vm.value

                if(vm.isMultiple){
                    if(value && value.length > 0){
                        const nextModel = value.map(selected => {
                            const selectedId = selected && selected.id !== undefined ? selected.id : selected
                            return vm.items.find(item => item.id.toString() === selectedId.toString()) || selected
                        })
                        vm.setModelIfChanged(nextModel)
                        return
                    }

                    vm.setModelIfChanged([])
                    return
                }

                if(value){
                    const selectedId = value && value.id !== undefined ? value.id : value
                    vm.setModelIfChanged(vm.items.find(item => item.id.toString() === selectedId.toString()) || value)
                    return
                }

                vm.setModelIfChanged(vm.items.length > 0 ? vm.items[0] : null)
            },
        },
        computed: {
                ...mapState(['currentProvider', 'branchOffices']),
            isMultiple(){
                return this.multiple !== undefined && this.multiple !== false
            },

            isRequired(){
              return this.required !== undefined && this.required !== false
            },

            hideOnOne(){
              return this.hideOnOneItem !== undefined && this.hideOnOneItem !== false
            },

            fixedToScope(){
              return this.onlyScoped !== undefined && this.onlyScoped !== false
            },

            items(){

                var vm = this
                var all = []

                if(!vm.branchOffices.length) return all

                var offices = vm.branchOffices

                offices.forEach((office) => {

                    all.push({
                        id: office.id,
                        name: office.name
                    })

                })

                if(vm.fixedToScope){
                    return all.filter(office => hasAccessToOffice(office.id))
                }

                return all

            }
        }
    }
</script>
